import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './ErrorPage.scss'

const NotFoundPage = () => {
  const { t } = useTranslation('common')

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__code">404</div>
        <h1 className="error-page__title">{t('errors.pageNotFoundTitle')}</h1>
        <p className="error-page__message">{t('errors.pageNotFoundMessage')}</p>
        <Link to="/" className="error-page__button">
          {t('errors.goHome')}
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPage
